<template>
  <div class="base-container__white" v-show="!changePasswordSuccess">
    <div class="pass-reset">
      <img src="@/assets/img/logo-wrap.svg" alt="INFRECT" />
      <div class="mt-60px">
        <h2>パスワードの再設定</h2>
      </div>
      <div class="mt-40px">
        <h3>新しいパスワードを設定してください。</h3>
      </div>
      <base-text-field placeholder="現在のパスワード" type="password" :width="360" class="mt-60px" v-model="oldPassword"></base-text-field>
      <div class="error-message" v-show="errorMessage">
        <span v-if="errorMessage?.oldPassword">{{ errorMessage.oldPassword }}</span>
      </div>
      <base-text-field placeholder="新しいパスワード" type="password" :width="360" class="mt-20px" v-model="password1"></base-text-field>
      <base-text-field placeholder="新しいパスワード確認用" type="password" :width="360" class="mt-20px" v-model="password2"></base-text-field>
      <div class="error-message" v-show="errorMessage">
        <span v-if="errorMessage?.newPassword">{{ errorMessage.newPassword[0] }}</span>
        <span v-else-if="!errorMessage?.oldPassword">{{ errorMessage }}</span>
      </div>
      <div class="error-message" v-show="formErrorMessage">{{ formErrorMessage }}</div>
      <div class="btn-container">
        <base-button size="wide" @click="submitChangePassword">パスワード再設定</base-button>
        <base-button class="ml-20px" size="short" color="dark" @click="cancelChangePassword">戻る</base-button>
      </div>
    </div>
  </div>
  <div class="base-container__white" v-show="changePasswordSuccess">
    <div class="reset-complete">
      <img src="@/assets/img/logo-wrap.svg" alt="INFRECT" />
      <div class="mt-60px">
        <h2>パスワードの設定完了</h2>
      </div>
      <div class="mt-40px">
        <h3>
          パスワードの再設定が完了しました。<br />
          早速ログインしてINFRECTを使ってみましょう！
        </h3>
      </div>
      <div class="mt-60px">
        <base-button size="wide" @click="resetToken">ログイン</base-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, reactive, toRefs } from "vue";
import BaseButton from "@/components/BaseButton.vue";
import BaseTextField from "@/components/BaseTextField.vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { PasswordResetParams } from "@/types";

export default defineComponent({
  name: "ChangePassword",
  components: { BaseButton, BaseTextField },
  setup() {
    const store = useStore();
    store.dispatch("users/changePasswordInitialize");
    const router = useRouter();
    const state = reactive({
      errorMessage: computed(() => store.state.users.errorMessage),
      changePasswordSuccess: computed(() => store.state.users.changePasswordSuccess),
      formErrorMessage: null as string | null,
      oldPassword: null as string | null,
      password1: null as string | null,
      password2: null as string | null,
    });
    const submitChangePassword = () => {
      store.dispatch("users/forgotPasswordResetInitialize");
      if (!state.oldPassword) {
        state.formErrorMessage = "現在のパスワードは必須です";
      } else if (!state.password1) {
        state.formErrorMessage = "新しいパスワードは必須です";
      } else if (!state.password2) {
        state.formErrorMessage = "新しいパスワード確認用は必須です";
      } else if (state.password1 !== state.password2) {
        state.formErrorMessage = "新しいパスワードと新しいパスワード確認用が違います";
      } else if (state.oldPassword === state.password1) {
        state.formErrorMessage = "現在のパスワードと新しいパスワードが同じです";
      } else {
        state.formErrorMessage = null;
        const params: PasswordResetParams = { oldPassword: state.oldPassword, newPassword: state.password1 };
        store.dispatch("users/changePassword", params);
      }
    };
    const cancelChangePassword = () => {
      router.push({ name: "AccountSetting" });
    };
    const resetToken = () => {
      store.dispatch("users/logOut");
    };
    return { ...toRefs(state), submitChangePassword, cancelChangePassword, resetToken };
  },
});
</script>

<style lang="scss" scoped>
@import "../../src/assets/styles/main";
.pass-reset {
  & h2 {
    color: map-get($colors, "blue400");
  }
  & h3 {
    font-weight: 500;
  }
  text-align: center;
  padding-top: 120px;
  & .btn-container {
    align-content: center;
    display: flex;
    width: fit-content;
    margin: 60px auto;
  }
}
.reset-complete {
  text-align: center;
  padding-top: 120px;
  & h2 {
    color: map-get($colors, "blue400");
  }
  & h3 {
    font-weight: 500;
  }
  & img {
    width: 160px;
    height: auto;
  }
}
.error-message {
  padding: 20px;
  color: map-get($colors, "accent");
}
</style>
